export default __webpack_public_path__ + "9a36b9cfae2dc89621f0719e47a39d0c.svg";